import { func, number, oneOf, oneOfType, string } from "prop-types";
import { useCallback, useEffect, useReducer } from "react";

import Datepicker from "web/Layout/Datepicker";
import __ from "web/Layout/Translations";

import classes from "./dateRange.scss";

const reducer = (state, action) => {
  switch (action.type) {
    case "from": {
      return {
        currentFrom: action.payload,
        currentTo: state.currentTo,
      };
    }
    case "to": {
      const fromProcessed = state.currentFrom || action.payload.min;
      return {
        currentFrom: fromProcessed,
        currentTo: action.payload.value,
      };
    }
    default:
      return state;
  }
};

const DateRange = ({
  min,
  max,
  labelFrom,
  labelTo,
  to,
  from,
  onChange,
  dataT1,
}) => {
  const [{ currentFrom, currentTo }, dispatch] = useReducer(reducer, {
    currentFrom: from,
    currentTo: to,
  });

  useEffect(() => {
    if (currentFrom || currentTo) onChange([currentFrom, currentTo]);
  }, [currentFrom, currentTo]);

  const changeFromHandler = useCallback(
    (value) => {
      dispatch({ type: "from", payload: value });
    },
    [dispatch]
  );
  const changeToHandler = useCallback(
    (value) => {
      dispatch({ type: "to", payload: { min, value } });
    },
    [dispatch]
  );

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <Datepicker
          className={classes.date}
          label={labelFrom}
          minDate="today"
          maxDate={max}
          defaultValue={currentFrom}
          onChange={changeFromHandler}
          dataT1={`${dataT1}_from`}
          placeholder={__("Data od..")}
        />
        <Datepicker
          className={classes.date}
          label={labelTo}
          minDate={min}
          defaultValue={currentTo}
          onChange={changeToHandler}
          dataT1={`${dataT1}_to`}
          placeholder={__("Data do..")}
        />
      </div>
    </div>
  );
};

DateRange.propTypes = {
  to: oneOfType([number, oneOf([null])]),
  from: oneOfType([number, oneOf([null])]),
  min: oneOfType([string, number]).isRequired,
  max: oneOfType([string, number, oneOf([null])]),
  labelFrom: string.isRequired,
  labelTo: string.isRequired,
  onChange: func,
  dataT1: string,
};

DateRange.defaultProps = {
  onChange: () => {},
  to: null,
  from: null,
  max: null,
  dataT1: "",
};

export default DateRange;
